import React from "react";
import "../../../../App.scss"
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import {  Stack, Typography, useTheme } from '@mui/material';
import { useTranslation } from "react-i18next";
import { Label } from "@mui/icons-material";



export default function Graph({ doubleGraph, graphData, isTraderGraph = false }) {
  const {t} = useTranslation()
  const theme = useTheme();
  let width = 475;
  if(isTraderGraph && graphData.length > 4) {
    width = graphData.length * 80
  }
  if(!isTraderGraph && graphData.length > 12) {
    width = graphData.length * 40
  }

  const height = (window.innerHeight - 310) / 2;

  const tickFormatter = (value, index) => {
    const limit = 10; // put your maximum character
    if (value.length < limit) return value;
    return `${value.substring(0, limit)}...`;
 };

const CustomTooltip = ({ active, payload, label }) => {
  console.log(active, payload, label," checkkkkkkkkkkkkkkk");
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`${label} : ${payload[0].value}`}</p>
        <div>
          {payload.map((pld) => (
            <div style={{ display: "inline-block", padding: 10 }}>
              <div style={{ color: pld.fill }}>{pld.value} %</div>
              <div>{pld.dataKey}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (<div className="custom-tooltip">fff</div>);
};

  return (
    <Stack style={{ background: "#fff", position: "relative", alignItems: "flex-start", }}>
      {graphData?.length > 0 ? <>
        <Stack direction="row">
          <Stack style={{ height: `${height}px`, width: "20px", alignItems: "center", justifyContent: "center", marginLeft: "20px", marginRight: "-25px" }}>
            <Typography color="#14285A" fontWeight="500" className='rotate-[-90deg] w-[120px]' style={{fontSize:'10px'}}>
              {t('EUA TRADED(%)')}
            </Typography>
          </Stack>
          <Stack className=" !z-[999] ">
            <BarChart
              width={60}
              height={height}
              data={graphData}

              margin={{
                top: 5,
                right: 0,
                left: 0,
                bottom: 30
              }}
            >
              <YAxis stroke="#14285A80" tick={{fontSize: '8px'}} domain={[0, 100]} />
              <Bar dataKey="Buy" fill={doubleGraph ? "#FFCC00" : theme.palette.primary.main} barSize={doubleGraph ? 0 : 0} />
              {doubleGraph ? <Bar dataKey="Sell" fill={theme.palette.primary.main} barSize={0} />
                : null}
            </BarChart>
          </Stack>
          <Stack className="!w-[480px]  overflow-x-auto">
            <BarChart
              width={width}
              height={height}
              data={graphData}
              margin={{
                top: 5,
                right: 0,
                left: 0,
                bottom: 0
              }}
            >
              <YAxis width={0} height={0} stroke="transparent" tick={{fontSize: '1px'}} domain={[0, 100]} />
              <XAxis dataKey="name"  angle={isTraderGraph ? 0 : 0} textAnchor={'middle'}  tick={{ fontSize:'10px',  overflow: 'hidden'}} tickFormatter={tickFormatter}  />
              <Tooltip   formatter={(value, name) =>  `${value}%` } />
              <Bar dataKey="Buy" fill={doubleGraph ? "#FFCC00" : theme.palette.primary.main} barSize={doubleGraph ? 10 : 10} />
              {doubleGraph ? <Bar dataKey="Sell" fill={theme.palette.primary.main} barSize={10} />
                : null}
            </BarChart>
          </Stack>
        </Stack>
        <Stack style={{ width: "100%", justifyContent: "start", paddingBottom: "20px", alignItems: "center" }}>
          <Typography style={{ color: "#14285A", fontWeight: "500", fontSize:'12px' }}>
          {isTraderGraph ? `${t('TRADERS')}`: `${t('Months')}`}
          </Typography>
        </Stack>
      </> :
        <Stack style={{ height: `${height}px`, width: "100%", alignItems: "center", justifyContent: "center", }}>
          <Typography>
            {t('No Data Found')}
          </Typography>
        </Stack>
      }
    </Stack>
  );
}